import React from 'react';
import { GiftIcon, PartyPopperIcon, CalendarDaysIcon, BrushIcon, RecycleIcon, TrophyIcon, HeadphonesIcon, ArrowRightIcon, SparklesIcon } from 'lucide-react';
const bonuses = [{
  num: '01',
  icon: PartyPopperIcon,
  title: 'Kit Accoglienza & Arredo Aula',
  desc: 'Decorazioni, cartelli e attività per un rientro a scuola indimenticabile.',
  value: '€ 9'
}, {
  num: '02',
  icon: CalendarDaysIcon,
  title: "L'Agenda dell'Insegnante d'Arte",
  desc: 'Il planner definitivo per organizzare lezioni, scadenze e scoperte creative.',
  value: '€ 7'
}, {
  num: '03',
  icon: BrushIcon,
  title: 'Flip-cards dei Grandi Maestri',
  desc: "Fiche didattiche sui geni dell'arte pronte da visualizzare o stampare.",
  value: '€ 9'
}, {
  num: '04',
  icon: RecycleIcon,
  title: 'Laboratori di Riciclo Creativo',
  desc: "10 progetti eco-friendly per educare alla sostenibilità e all'Agenda 2030.",
  value: '€ 9'
}, {
  num: '05',
  icon: TrophyIcon,
  title: 'Diplomi e Certificati Finali',
  desc: "Attestati d'onore per premiare il talento e l'impegno dei tuoi piccoli artisti.",
  value: '€ 7'
}, {
  num: '06',
  icon: HeadphonesIcon,
  title: "Audio-Storie d'Arte",
  desc: "Racconti suggestivi da leggere per immergere la classe nella magia dell'opera.",
  value: '€ 8'
}];
export function BonusSection() {
  return <section className="relative w-full bg-bg-main py-16 sm:py-24 px-4 overflow-hidden" data-id="element-27">
      {/* Background glow */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[700px] h-[500px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(ellipse, rgba(251,191,36,0.10) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-28"></div>

      <div className="relative max-w-4xl mx-auto z-10" data-id="element-29">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-14" data-id="element-30">
          <span className="inline-flex items-center gap-1.5 text-secondary font-bold text-[11px] sm:text-xs uppercase tracking-[0.15em] bg-secondary/10 border border-secondary/30 px-3 py-1.5 rounded-full mb-4" data-id="element-31">
            <GiftIcon className="w-3.5 h-3.5" data-id="element-32" />
            Regali esclusivi
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight leading-[1.1] mb-4" data-id="element-33">
            6 Bonus{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-secondary to-amber-500" data-id="element-34">
              in omaggio
            </span>
            <br className="hidden sm:block" data-id="element-35" /> con il tuo Kit.
          </h2>
          <div className="inline-flex flex-col sm:flex-row items-center gap-2 sm:gap-3" data-id="element-36">
            <span className="text-text-sec text-base sm:text-lg font-medium" data-id="element-37">
              Valore totale dei bonus:
            </span>
            <span className="inline-flex items-center gap-2" data-id="element-38">
              <span className="text-badge-red font-black text-xl sm:text-2xl line-through opacity-80" data-id="element-39">
                € 49
              </span>
              <span className="bg-cta-green/15 text-cta-green border border-cta-green/30 font-black text-xs sm:text-sm px-3 py-1 rounded-full" data-id="element-40">
                € 0,00 OGGI
              </span>
            </span>
          </div>
        </div>

        {/* Bonus list */}
        <div className="space-y-3 sm:space-y-4 mb-10 sm:mb-12" data-id="element-41">
          {bonuses.map((bonus, i) => {
          const Icon = bonus.icon;
          return <div key={i} className="group relative bg-bg-alt rounded-2xl border border-border-light hover:border-secondary/40 p-4 sm:p-5 flex items-center gap-3 sm:gap-5 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(251,191,36,0.15)] overflow-hidden" data-id="element-42">
                {/* Hover glow */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{
              background: 'radial-gradient(circle at left, rgba(251,191,36,0.10) 0%, transparent 60%)'
            }} aria-hidden="true" data-id="element-43"></div>

                {/* Number + Icon stack */}
                <div className="relative z-10 flex flex-col items-center gap-1 flex-shrink-0" data-id="element-44">
                  <span className="text-secondary/50 font-black text-[10px] sm:text-xs tracking-widest" data-id="element-45">
                    BONUS {bonus.num}
                  </span>
                  <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-gradient-to-br from-secondary/25 to-amber-500/5 border border-secondary/30 flex items-center justify-center transition-transform duration-300 group-hover:scale-110 group-hover:rotate-[-4deg]" data-id="element-46">
                    <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-secondary" strokeWidth={2} data-id="element-47" />
                  </div>
                </div>

                {/* Info */}
                <div className="relative z-10 min-w-0 flex-1" data-id="element-48">
                  <h4 className="text-text-main font-black text-base sm:text-xl leading-tight mb-1" data-id="element-49">
                    {bonus.title}
                  </h4>
                  <p className="text-text-sec text-xs sm:text-sm leading-snug" data-id="element-50">
                    {bonus.desc}
                  </p>
                </div>

                {/* IN OMAGGIO badge */}
                <div className="relative z-10 flex flex-col items-end gap-1 flex-shrink-0" data-id="element-51">
                  <span className="text-text-sec font-medium text-[10px] sm:text-xs line-through" data-id="element-52">
                    {bonus.value}
                  </span>
                  <span className="inline-flex items-center gap-1 bg-gradient-to-r from-secondary to-amber-400 text-bg-dark px-2.5 sm:px-3 py-1 sm:py-1.5 rounded-lg font-black text-[10px] sm:text-xs uppercase tracking-wider shadow-[0_2px_8px_rgba(251,191,36,0.4)]" data-id="element-53">
                    <SparklesIcon className="w-3 h-3" strokeWidth={3} data-id="element-54" />
                    In omaggio
                  </span>
                </div>
              </div>;
        })}
        </div>

        {/* Closing CTA */}
        <div className="text-center" data-id="element-55">
          <a href="#pricing" className="group inline-flex items-center gap-2 text-text-main hover:text-secondary font-bold text-base sm:text-lg transition-colors" data-id="element-56">
            <span data-id="element-57">Voglio i miei 6 bonus in omaggio</span>
            <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" strokeWidth={3} data-id="element-58" />
          </a>
        </div>
      </div>
    </section>;
}